import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">
                {/* Header - matches login page */}
                <div className="text-center">
                    <img 
                        src="/logo-vertical-black.png" 
                        alt="IntelliDrive" 
                        className="mx-auto h-36 w-auto"
                    />
                    <p className="text-sm text-gray-600 mb-2">
                        Intelligent Driver Compliance Platform
                    </p>
                </div>
                
                {/* 404 Error */}
                <div className="text-center space-y-6">
                    <div>
                        <h1 className="text-6xl font-bold mb-4" style={{ color: '#231f20' }}>404</h1>
                        <h2 className="text-2xl font-bold mb-4" style={{ color: '#231f20' }}>
                            Page Not Found
                        </h2>
                        <p className="text-gray-600">
                            The page you're looking for doesn't exist in the IntelliDrive platform.
                        </p>
                    </div>

                    {/* Action Buttons */}
                    <div className="space-y-4">
                        <button
                            onClick={() => navigate('/dashboard')}
                            className="w-full flex items-center justify-center px-6 py-3 text-white text-sm font-medium rounded-md hover:opacity-90 transition-opacity"
                            style={{ backgroundColor: '#69BE28' }}
                        >
                            <Home className="w-5 h-5 mr-2" />
                            Return to Dashboard
                        </button>
                        
                        <button
                            onClick={() => navigate(-1)}
                            className="w-full flex items-center justify-center px-6 py-3 border border-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-50 transition-colors"
                        >
                            <ArrowLeft className="w-5 h-5 mr-2" />
                            Go Back
                        </button>
                    </div>

                    {/* Help Text */}
                    <p className="text-xs text-gray-500">
                        Need help? Contact your system administrator.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;